import React from "react";
import PropTypes from "prop-types";

import { BasePager } from "../BasePager";
import { Button } from "../../Button";

import { staticPagerPathSegment } from "./path";

function StaticPager({
    baseUrl = "/",
    urlFragment = "",
    className = "",
    currentPage = 1,
    lastPage
}) {
    return (
        <BasePager
            currentPage={currentPage}
            lastPage={lastPage}
            className={className}
            onRenderPage={(page, isActive, label) => {
                // document.getElementById(sectionId)?.scrollIntoView();
                const targetUrl = `${baseUrl}${
                    page > 1 ? `${staticPagerPathSegment}/${page}/` : ""
                }${urlFragment.length > 0 ? `#${urlFragment}` : ""}`;

                return (
                    <Button
                        type="primary"
                        renderAs="link"
                        active={isActive}
                        to={targetUrl}
                    >
                        {label}
                    </Button>
                );
            }}
        />
    );
}

StaticPager.defaultProps = {
    currentPage: 1,
    baseUrl: "/",
    urlFragment: "",
    className: ""
};

StaticPager.propTypes = {
    lastPage: PropTypes.number.isRequired,
    currentPage: PropTypes.number,
    baseUrl: PropTypes.string,
    urlFragment: PropTypes.string,
    className: PropTypes.string
};

export { StaticPager };
